import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Dreamy%20anime%20style%20cityscape%20at%20sunset%20with%20cherry%20blossoms%20floating%20in%20the%20air%2C%20soft%20pink%20and%20orange%20sky%2C%20Japanese%20animation%20aesthetic%2C%20warm%20and%20nostalgic%20atmosphere%2C%20beautiful%20scenery%20with%20glowing%20particles%2C%2C%20cinematic%20composition%20with%20depth%20of%20field&width=1800&height=900&seq=home-hero-01&orientation=landscape')`,
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <h1 className="font-heading text-4xl md:text-6xl text-white text-center leading-tight tracking-wide">
          欢迎来到<span className="text-primary-400">萝幼社</span>
        </h1>
        <p className="mt-5 text-base md:text-lg text-white/80 text-center max-w-2xl leading-relaxed">
          专注于二次元文化的正版授权内容平台，汇聚海量优质创作资源，为广大二次元爱好者提供丰富的视觉内容与社区互动体验。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4 mt-8">
          <Link
            to="/category/illustration"
            className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            开始探索
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 rounded-full border border-white/40 text-white font-medium text-sm hover:bg-white/10 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}